/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiVersionGet } from '../fn/version/api-version-get';
import { ApiVersionGet$Params } from '../fn/version/api-version-get';

@Injectable({ providedIn: 'root' })
export class VersionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiVersionGet()` */
  static readonly ApiVersionGetPath = '/api/version';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVersionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiVersionGet$Response(params?: ApiVersionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiVersionGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVersionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiVersionGet(params?: ApiVersionGet$Params, context?: HttpContext): Observable<string> {
    return this.apiVersionGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
